// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import hui from "h_ui/dist/h_ui.min.js";
import "h_ui/dist/h_ui.min.css";
import "./style/console.scss";
import "./style/main.scss"; // 开发theme时修改main.scss中引入的custom.scss
import wx from "weixin-jsapi"; // 引入微信sdk
import axios from "axios";
import Qs from "qs";
import mixin from "@/mixins/gioTrack";
import { isLogin } from "./api/login.js";
import { selectSysUserDTO } from "./api/uPlusApi";
import Dialog from "@/components/dialog";
import GlobalMethod from "@/utils/user";
import connectUplus from "@/components/uplus/connect";
import lazyLoadImg from "@/components/uplus/lazyLoadImg";
import animated from "animate.css";
import "element-ui/lib/theme-chalk/index.css";
window.i = "";
Vue.use(animated);
import JsonViewer from "vue-json-viewer";
// 播放器相关
import "video.js/dist/video-js.css";
import ref from "vue-ref";
import "@/utils/filters.js";
import VideoPlayer from "vue-video-player-videojs-7";
window.videojs = VideoPlayer.videojs;
require("video.js/dist/video-js.css");
require("vue-video-player-videojs-7/src/custom-theme.css");
require("video.js/dist/lang/zh-CN");
Vue.use(ref, { name: "ant-ref" });
Vue.component("connectUplus", connectUplus);
Vue.component("lazyLoadImg", lazyLoadImg);
Vue.use(Dialog);
Vue.use(GlobalMethod);
Vue.use(hui);
Vue.use(JsonViewer);
Vue.use(VideoPlayer);
Vue.prototype.LOCAL_CONFIG = window.LOCAL_CONFIG;
Vue.prototype._bus = new Vue();
Vue.config.productionTip = false;
Vue.prototype.$setUplusUser = routerObj => {
  selectSysUserDTO().then(res => {
    const { organizationId, isInner, userType } = res.data || {};
    let user_type_str = "";
    if (!organizationId) {
      user_type_str = "custom"; // 普通用户或者游客
    } else if (organizationId && String(isInner) === "1") {
      user_type_str = "innerOrg"; // 内部机构【hs员工】
    } else if (organizationId && String(isInner) === "0") {
      // user_type_str = 'outerOrg' // 外部机构【hs客户用户】
      if (String(userType) === "1") {
        user_type_str = "outerOrgMain"; // 外部机构【hs客户用户-主账号】
      } else if (String(userType) === "0") {
        user_type_str = "outerOrgChild"; // 外部机构【hs客户用户-子账号】
      }
    }
    res.data.user_type_str = user_type_str;
    store.commit("SET_UPLUS_USER", res.data);
    // 如果不是string类型【即不是token的话】，那么就是routerBeforeEach传进来的to路由对象
    if (routerObj) {
      setBuried(routerObj);
    }
  });
};
//公共动画方法
Vue.prototype.animateCSS = (element, animation, prefix = "animate__") =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const node = document.querySelector(element);

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation();
      node.classList.remove(`${prefix}animated`, animationName);
      resolve("Animation ended");
    }

    node.addEventListener("animationend", handleAnimationEnd, { once: true });
  });
// 全局混入埋点信息
Vue.mixin(mixin);
Vue.config.debug = false;

Vue.prototype.wxShare = function(title, desc, link, imgUrl) {
  const url = window.location.href;
  let param = {
    url: url
  };
  title = title == "" || !title ? "恒生GTN" : title;
  desc = desc == "" || !desc ? "动动手指，快速了解前沿金融科技" : desc;
  link = link == "" || !link ? window.location.href : link;
  imgUrl =
    imgUrl == "" || !imgUrl
      ? "https://" + location.hostname + "/r/cms/www/itn/images/h5/share.png"
      : imgUrl;
  axios({
    url: "/cloud/open/wechat/main/info.json",
    data: Qs.stringify(param),
    method: "post",
    headers: {
      "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    withCredentials: true
  })
    .then(response => {
      let data = response.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见附录1
        jsApiList: [
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "onMenuShareQQ"
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
    })
    .catch(err => {
      // ...
      console.log(err);
    });
  wx.ready(() => {
    // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，
    // 则可以直接调用，不需要放在ready函数中。
    wx.onMenuShareAppMessage({
      // 分享给朋友
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      // 用户确认分享后执行的回调函数
      success: function() {
        // console.log('分享到朋友成功')
      },
      // 用户取消分享后执行的回调函数
      cancel: function() {
        // console.log('分享到朋友取消')
      }
    });
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      // 用户确认分享后执行的回调函数
      success: function() {
        // console.log('分享到朋友成功')
      },
      // 用户取消分享后执行的回调函数
      cancel: function() {
        // console.log('分享到朋友取消')
      }
    });
    wx.onMenuShareQQ({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      // 用户确认分享后执行的回调函数
      success: function() {
        // console.log('分享到朋友成功')
      },
      // 用户取消分享后执行的回调函数
      cancel: function() {
        // console.log('分享到朋友取消')
      }
    });
  });
};

window.addEventListener(
  "message",
  function(e) {
    if (e.data.method == "loginSync") {
      isLogin()
        .then(res => {
          if (res.login == true) {
            // Vue.prototype.$setHideNickName(res)
            store.commit("SET_USER", res);
            this.$setUplusUser();
          }
        })
        .catch(res => {});
    }
  },
  false
);
router.afterEach((to, from) => {
  hui.hLoadingBar.finish();
  if (to.meta.sideBar === false) {
    setTimeout(() => {
      const guajian = document.getElementById("gtn-gj-id");
      if (guajian) {
        guajian.style.display = "none";
      }
    }, 4);
  }
  if (to.meta.footerShow === false) {
    setTimeout(() => {
      const footer = document.getElementsByClassName("footer-wrapper");
      if (footer && footer[0]) {
        footer[0].style.display = "none";
      }
    }, 100);
  }
});
/* eslint-disable no-new */
window.newWebSitVm = new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});

// 设置埋点
function setBuried(to) {
  const { user, uPlusUser, hsid } = store.getters;
  let { loginAccount, authId } = uPlusUser || {};
  loginAccount = loginAccount || {};
  const { matched } = to;
  gdp("setUserId", hsid);
  gdp("track", "GL_loginUserPageBrowse", {
    routeName_var: to.name,
    pageName_var: document.title,
    appId_var: 5525,
    domainId_var: user.domain_account || "-",
    hsUserId_var: authId || "-",
    deviceType_var: "Web",
    moduleClassify_var: to.meta.moduleClassify
      ? to.meta.moduleClassify
      : matched.length
      ? matched[0].meta.moduleClassify
      : "",
    moduleSecondaryClassify_var: to.meta.moduleSecondaryClassify
      ? to.meta.moduleSecondaryClassify
      : matched.length
      ? matched[0].meta.moduleSecondaryClassify
      : "",
    customerSynergyNo_var: user.customer
      ? user.customer.customer_synergy_no
      : "",
    customerName_var: user.customer ? user.customer.customer_name : "",
    customer_account: loginAccount.customerAccountId || "",
    personal_account: loginAccount.personalAccountId || "",
    staff_account: loginAccount.staffAccountId || "",
    enterprise_account: loginAccount.enterpriseAccountId || "",
    enterpriseName: loginAccount.customerName || "",
    customer_no: loginAccount.customerNo || "",
    loginAccountId: loginAccount.accountId || "",
    loginAccountType: loginAccount.accountType || "",
    ...genGioPageParams(to)
  });
}

// 生成gio埋点的页面参数【如：课程详情页面需要携带课程id，组件页面需要携带组件id等】
function genGioPageParams(routeObj) {
  if (!routeObj) {
    return {};
  }
  const pathToGioParamKey = {
    courseDetail: "courseId_var", // 课程
    serviceDetail: "moduleId_var", // 组件
    productDetail: "M_productId_var", // 产品
    solutionDetail: "M_solutionId_var" // 解决方案
  };
  const pathToPathKey = {
    courseDetail: "id", // 课程
    serviceDetail: "id", // 组件
    productDetail: "id", // 产品
    solutionDetail: "id" // 解决方案
  };
  const keys = Object.keys(pathToGioParamKey);
  for (let i = 0, len = keys.length; i < len; i++) {
    if (routeObj.path.indexOf(keys[i]) > -1) {
      const pathParamKey = pathToPathKey[keys[i]];
      const gioParamKey = pathToGioParamKey[keys[i]];
      return {
        [gioParamKey]:
          routeObj.params[pathParamKey] || routeObj.query[pathParamKey] || ""
      };
    }
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/gtn/main.js